export default {"src":"https://cdn.jetlend.ru/_next/static/media/documents-not-found.2a4d6e67.svg","height":227,"width":296,"blurWidth":0,"blurHeight":0};